export const upload_api = {
  url: '',
  title: '导入',
  method: 'post'
}

export const export_api = {
  url: 'appraiseListsDownload',
  title: '导出',
  method: 'post'
}

export const list_api = {
  url: 'appraiseLists',
  title: '列表',
  method: 'post'
}


// WEBPACK FOOTER //
// ./src/views/base/comment/desc.js